export default "__VITE_ASSET__HMrKYZQ3__"